/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { styled, alpha, Button, ButtonProps } from "@mui/material";
import { useClickHandler } from "hooks/ClickHandleHook";

export const BorderedButton: React.FC<ButtonProps> = ({
  children,
  variant,
  onClick,
  ...others
}) => {
  const onClickHandler = useClickHandler(onClick);
  return (
    <StyledButton variant="outlined" onClick={onClickHandler} {...others}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: "6.5em",
  padding: theme.spacing(0.4, 2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: "2.0em",
  borderColor: theme.palette.grey[500],
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: "normal",
  boxShadow: theme.shadows[3],
  "&:focus": {
    borderColor: theme.palette.grey[500],
  },
  "&:active": {
    boxShadow: "none",
  },
  "&:disabled": {
    backgroundColor: alpha(theme.palette.background.paper, 0.2),
    boxShadow: "none",
  },
}));
